<template>
  <div class="cert" v-loading="pageLoading">
    <div class="passAll" v-if="isPassAll && baseInfo && baseInfo.is_cert && activeTab == 6">
      <div>
        <img
          src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/passAllClose.png"
          class="close"
          @click="isPassAll = false"
        />
        <img
          src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/examinPassAll.png"
        />
      </div>
    </div>
    <div class="content"  v-if="banner">
      <div class="left">
        <div class="top">
          <van-image
            class="cover"
            width="100%"
            fit="cover"
            :src="banner.cover"
          >
          </van-image>
          <div class="detail">
            <p class="title">全国托育服务从业人员培训课程</p>
            <el-button :disabled="btnLoading" :loading="btnLoading" @click="handleSignOrStudy" style="margin-left: 300px;">{{ alreadySinIn ? '我要学习' : '我要报名' }}</el-button>
          </div>
        </div>
      </div>
      <div class="right">
        <right/>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import certSave from "./CertSave.vue";
import right from "@/components/DetailRight.vue";
import lessonList from "@/components/DetailLessonList.vue";
export default {
  components: { right, lessonList },
  name: "detail",
  
  data() {
    return {
      isPassAll: true,
      pass:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/pass.jpg",
      noPass:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/noPass.jpg",

      typeList: [],
      allTypeList: [
        {
          name: "课程介绍",
          id: 1,
        },
        {
          name: "课程列表",
          id: 2,
        },
        {
          name: "课程讲义",
          id: 3,
        },
        {
          name: "思维导图",
          id: 4,
        },
        {
          name: "示范课程",
          id: 5,
        },
        {
          name: "课程考试",
          id: 6,
        },
        {
          name: "纸质书籍",
          id: 7,
        },
        {
          name: "培训证书",
          id: 8,
        },
      ],
      baseInfo: null,
      lessonNum: 0,
      lessonList: [], //课程列表
      down_list:[],//实操课程
      map: [], //思维导图
      handouts: [], //讲义
      demonstrate: [], //示范课程
      paper_book: [], //纸质书籍
      books: [], //推荐书籍
      payUrl: "",
      orderShow: false,
      dialogVisible: false,
      pageLoading: true,
      buyTimer: null,
      buyTime: 300,
      menu: 2,
      id: 0,
      lesson: "",
      list: [],
      activeTab: 1,
      textContent: "",
      color: ["#666", "#FF4D41", "#6DD400"],
      payTimer: null,
      isPay: false,
      examinList: [], //理论课程考试
      examinListCe:[],
      examinListShiCe:[],
      examinListShi: [],//实操课程考试
      testInfo: {},
      trainSignInfo: {},
      uploading: null,
      alreadySinIn: false,
      banner: {},
      btnLoading: false
    };
  },
  mounted() {

    this.$router.onReady(() => {
      this.getBanner();
      this.handleTrainLogin();
    });
  },
  methods: {
    async getBanner() {
      this.pageLoading = true;
      let res = await this.$api({
        method: "get",
        url: "/api/index?flat_id="+this.plat,
      });
      this.pageLoading = false;
      console.log(res)
      if (res.code == 0) {
        this.banner = (res.data.banner || [])[0] || {};
      }
    },
    async handleTrainLogin(){
      let token = await this.$until.getTrainToken();
      let trainLoginRes = await this.$request.handleTrainLogin({ token: token, userId: this.userId })
      if( trainLoginRes.code == 200 ){
         this.trainSignInfo = trainLoginRes.data;
         this.alreadySinIn = trainLoginRes.data.enroll == 1 ? true : false;
      }
    },
    async handleSignOrStudy(){
      if( !this.alreadySinIn ){
        this.btnLoading = true;
        let token = await this.$until.getTrainToken();
        let res = await this.$request.handleTrainEnroll({ token: token, userId: this.userId });
        this.btnLoading = false;
        if (res.code == 200) {
          this.$toast("报名成功");
          // 报名成功后重新登录，获取跳转地址等数据
          this.handleTrainLogin();
        }else{
          console.log('res', res);
          let { failList = [] } = res.data || {};
          if( failList[0] ){
            this.$toast(failList[0].error);
          }else{
            this.$toast(res.msg || "当前报名人数过多，请稍后重试");
          }
        }
      }else{
        window.open(this.trainSignInfo.redirectUrl, '__black')
      }
    },
 
    async getData(type) {
      if (!this.isPay && !type) this.pageLoading = true;
      let res = await this.$request.tuoyuDetail({ discipline_id: this.id });

      this.pageLoading = false;
      this.lessonList = []
      this.demonstrate =[]
      this.down_list = []
      if (res.code == 0) {
        this.lessonList = res.data.list; //课程列表
        this.lessonNum = res.data.course_num;
       
        this.baseInfo = res.data.base; //课程介绍
        // this.baseInfo.test_message = res.data.test_message;
        this.baseInfo.is_cert = res.data.is_cert;
        this.baseInfo.discipline_id = res.data.base.id;
        this.baseInfo.test_message = res.data.test_message;
        if(this.baseInfo.is_cert){
          this.$nextTick(()=>{
            this.$refs.cert.getData(res.data.base.id)
          })
        }
        
        let examRes = await this.$request.detailExaminList(res.data.base.id);
        if (examRes.code == 0) {
            this.examinListCe = examRes.data && examRes.data.ce? [examRes.data.ce] : [];
            this.examinList = examRes.data && examRes.data.zheng? [examRes.data.zheng] : [];
          } else {
            this.$toast(examRes.msg);
          }
   
        let typeShow = [
          true,
          this.lessonList.length > 0 || this.down_list.length > 0,
          this.handouts.length,
          this.map.length,
          this.demonstrate.length,
          this.examinList.length || this.examinListCe.length || this.examinListShiCe.length || this.examinListShi.length,
          this.paper_book.length,
          res.data.is_cert,
        ];
        if(this.id=='588'){
          this.allTypeList[0].name="培训简介"
        }
        this.typeList = this.allTypeList.filter((item, index) => {
          return typeShow[index];
        });
        // 1 为课程  2为培训

        // this.activeTab = this.ifVIPDetail ? 0 : 1
        // console.log(this.typeList)
        if (this.isPay) {
          if (!res.data.is_buy) {
            this.payTimer = setTimeout(() => {
              this.getData();
            }, 1000);
          } else {
            this.isPay = false;
            this.dialogVisible = false;
          }
        }
      } else {
        this.$toast(res.msg);
      }

      // let res2 = await this.$request.tuoyuDetailBooks({
      //   goods_category_id: this.baseInfo.category_id,
      // });
      // if (res2.code == 0) {
      //   this.books = res2.data;
      // } else {
      //   this.$toast(res2.msg);
      // }

    },
    flatArr(arr, idArr) {
      let myArr = [];

      arr.forEach((item) => {
        if (item.lesson && item.lesson.length) {
          // console.log("lesson");
          let arr = [
            { label: "lessonId", value: item.id },
            { label: "myType", value: "chapter" },
          ];
          // console.log(idArr);
          myArr.push(...this.flatArr(item.lesson, [...idArr, ...arr]));
        } else if (item.speak && item.speak.length) {
          // console.log("speak");
          let arr = [
            { label: "chapterId", value: item.id },
            { label: "myType", value: "speak" },
          ];
          myArr.push(...this.flatArr(item.speak, [...idArr, ...arr]));
        } else {
          // console.log("none");
          idArr.forEach((v) => {
            item[v.label] = v.value;
          });
          myArr.push(item);
        }
      });
      return myArr;
    },
    
    play(item) {
      if (!item.resource.length) {
      }
      let { ali_media_id, ccid, url, id } = item.resource[0];
      let name = item.lesson_name;
      // console.log(ali_media_id, ccid);
      let videoId = ali_media_id;
      // if(item.is_buy != 1 && item.is_show != 1){ //既没有购买，也不是试看视频
      //     this.$toast('请购买后开始学习')
      //     return
      // }
      this.$store.commit("SET_VIDEO", item);
      // console.log(url);
      let type = "ali";
      if (ccid && ccid != "undefined") {
        type = "cc";
        videoId = ccid;
      } else if (url) {
        type = "url";
      } else if (!ali_media_id) {
        // console.log("none");
        this.$toast("当前视频未上传");
        return;
      }
      // console.log("**");
      this.$router.push(
        `./player2?goods_id=${this.id}&lessonId=${item.lesson_id}&from=课程`
      );
    },

    jumpDetail(item) {
      this.$router.push(`./detail?id=${item.id}`);
    },
    toPage(url) {
      this.$router.push(url);
    },
  },
  computed: {
    partalName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
    userName() {
      return localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).nickname : null;
    },
    userId() {
      return localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).id : null;
    },
    userMMobile() {
      return localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).mobile : null;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  watch:{
    isLogin(){
      if(this.isLogin){
        if (this.$route.query.id) {
          this.id = this.$route.query.id;
          this.activeTab = this.$route.query.activeTab || 1;
          this.getData();
        }
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    // console.log("beforeRouteUpdate");
    // console.log(to);
    this.id = to.query.id;
    if(this.id=='588'){
        this.allTypeList[0].name="培训简介"
      }else{
        this.allTypeList[0].name="课程介绍"
      }
    this.activeTab = this.$route.query.type == "video" ? 2 : 1;
    this.getData();
    next();
  },
  beforeDestroy() {
    clearInterval(this.payTimer);
  },
};
</script>
<style lang="scss">
body {
  background: #fff;
}
.videoUpload{
  .el-loading-spinner i{
    font-size: 28px;
  }
  .el-loading-spinner .el-loading-text{
    font-size: 20px;
  }
}
</style>
<style lang="scss" scoped>
.examinTitle{
  font-size: 18px;
  padding-bottom: 8px;
  padding-left: 10px;
  font-weight: bold;
  color: #222222;
  padding-top: 20px;
}
.certGet{
  margin: 20px auto 20px;
  cursor: pointer;
  width: 308px;
  height: 42px;
  text-align: center;
  line-height: 42px;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  background: #0080d6;
  border: 0;
  display: block;
}
.passAll {
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    position: relative;
    .close {
      position: absolute;
      color: #fff;
      right: 0px;
      top: -8px;
      font-size: 30px;
      cursor: pointer;
    }
  }
}
:deep .el-dialog {
  margin-top: 0 !important;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
:deep .orderDialog {
  overflow: hidden;
  border-radius: 20px;
  .el-dialog__header {
    padding: 0 20px;
    height: 54px;
    display: flex;
    align-items: center;

    .el-dialog__title {
      font-size: 22px;
      color: #333333;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
}
.coverImg {
  img {
    display: block;
    max-width: 100%;
    width: auto;
    margin: 0 auto;
  }
  .btn {
    margin: 10px auto 20px;
    cursor: pointer;
    width: 208px;
    height: 42px;
    text-align: center;
    line-height: 42px;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    background: #0080d6;
  }
}
.examin-content {
  display: flex;
  align-items: center;
  width: 100%;
  background: #f7f7f7;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 20px;
  padding: 30px 20px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #666666;
}
.examin-content .examinBtn {
  width: 122px;
  text-align: center;
  padding: 10px 0;
  color: #fff;
  border-radius: 5px;
  .isPass {
    margin: 0 auto 20px;
    cursor: pointer;
    height: 37px;
  }
  .btn {
    width: 100%;
    height: 34px;
    line-height: 34px;
    background: #fff;
    color: #0080d6;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      background: #0080d6;
      color: #fff;
    }
  }
}
.opacity {
  opacity: 0.5;
}
.examin-content .examinLeft {
  flex: 1;
}
.examin-content .examinLeft .examinTitle {
  color: #000;
  width: 100%;
  font-size: 16px;
  margin-bottom: 16px;
}
.examin-content .examinLeft .examinDesc {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  img {
    margin-right: 8px;
  }
}
.examin-content .examinLeft .score span {
  margin-right: 50px;
}
.orderShow {
  display: flex;
  padding: 0 20px;
  margin-bottom: 20px;
  .detail {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .cover {
    width: 179px !important;
    height: 101px;
    margin-right: 20px;
    border-radius: 10px;
    overflow: hidden;
    flex-shrink: 0;
  }
  .title {
    font-size: 20px;
    color: #333;
    font-weight: bold;
    overflow: hidden;
    display: -webkit-box;
    /*弹性伸缩盒子*/
    -webkit-box-orient: vertical;
    /*子元素垂直排列*/
    -webkit-line-clamp: 2;
    /*可以显示的行数，超出部分用...表示*/
    text-overflow: ellipsis;
    /*（多行文本的情况下，用省略号“…”隐藏溢出范围的文本)*/
  }
  .number {
    font-size: 14px;
  }
  .pay {

    font-size: 20px;
    color: #0080d6;
  }
}
.orderBtn {
  width: 100%;
  height: 54px;
  display: flex;
  padding: 0 20px;
  align-items: center;
  justify-content: space-between;
  border-top: 1px dashed #f1f1f1;
  p {
    font-size: 14px;

    span {
      font-size: 20px;
      color: #0080d6;
    }
  }
  p:nth-child(2) {
    width: 116px;
    height: 36px;
    font-size: 16px;
    background: #0080d6;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    color: #ffffff;
    cursor: pointer;
  }
}
:deep .payDialog {
  overflow: hidden;
  border-radius: 20px;
  text-align: center;
  .el-dialog__body {
    padding: 0;
  }
}
.toPay {
  padding-bottom: 30px;
  span {
    color: #666;
    display: block;
    padding-bottom: 20px;
  }
  img {
    width: 200px;
  }
  > p {
    cursor: pointer;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    padding: 10px 0;
    width: 200px;
    text-align: center;
    margin: 20px auto 0;
  }
}
.cert {
  min-height: calc(100vh - 230px);
  overflow: hidden;
  padding-top: 30px;
  .article {
    width: 960px;
    background: #fff;
    min-height: 100vh;
    margin: 20px auto;
    padding: 30px;

    .art-title {
      font-size: 32px;
      margin-bottom: 20px;
    }

    .art-user {
      display: flex;
      align-items: center;
    }

    .user-msg {
      font-size: 16px;
      color: #333;
      margin-left: 10px;

      .sub {
        font-size: 12px;
        color: #666;
      }
    }

    .art-content {
      font-size: 17px;
      word-break: break-word;
      line-height: 1.6;
      margin-top: 16px;
      color: #121212;
      font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC,
        Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei,
        sans-serif;
    }
  }
}

.content {
  display: flex;
  justify-content: space-between;

  .left {
    flex: 0 0 800px;
    border-radius: 12px;
    margin-top: 30px;

    .top {
      display: flex;
      background: #f9f9f9;
      padding: 20px 20px;
      position: relative;
      border-radius: 10px;
      .tip {
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 1;
        img {
          width: 50px;
          // height: 35px;
        }
      }
      .cover {
        width: 300px;
        flex: 0 0 300px;
        margin-right: 20px;
        border-radius: 10px;
        overflow: hidden;
      }

      .detail {
        flex: 0 1 auto;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: space-between;
        div {
          display: flex;
        }
        .title {
          color: #333;
          font-weight: 500;
          font-size: 26px;
          line-height: 36px;
        }

        .number {
          flex: 1;
          color: #666;
          font-size: 14px;
          margin-top: 5px;
        }
        .pay {
          background: rgb(164, 0, 1);
          color: #fff;
          padding: 0 20px;
          margin-top: 20px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 16px;
          color: #fff;
          &:first-child {
            background: linear-gradient(-180deg, #51b4f7 0%, #0181d6 100%);
          }
          &:nth-child(2) {
            color: #633b11;
            background: linear-gradient(-180deg, #f4cfa7 0%, #daa36c 100%);
          }
        }
      }
    }
    .type {
      display: flex;
      align-items: center;
      margin-top: 30px;
      margin-bottom: 20px;
      border-bottom: 1px solid #dddddd;
      .type-item {
        margin-right: 10px;
        color: #7f7f7f;
        font-size: 20px;
        padding-bottom: 10px;
        margin-right: 40px;
        cursor: pointer;
        &:last-of-type {
          margin-right: 0;
        }
      }
      .active {
        background: none;
        color: #333;
        font-weight: bold;
        border-bottom: 4px solid #0080d6;
      }
    }
    .typeMore {
      // justify-content: space-between;
    }
    .typeLess {
      // justify-content: flex-start;
      .type-item {
        // margin-right: 50px;
      }
    }
    .detailContent {
      background: #fff;
      border-radius: 10px;
      padding-bottom: 20px;
      overflow: hidden;
    }

    .lesson-list {
    }
    .html {
      margin-top: 20px;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      // flex-direction: column;

      ::v-deep img {
        margin: 0 auto;
        display: block;
        max-width: 100%;
      }
    }
  }

  .right {
    width: 360px;
    overflow: hidden;
    margin-top: 30px;
  }
}
</style>

<style lang="scss"></style>
